export const FLAG_ICON_COUNTRY_CODES = ['us', 'gb', 'au', 'ca', 'jp', 'ie', 'es', 'fr'] as const;

export type FlagIconProps = {
  countryCode: (typeof FLAG_ICON_COUNTRY_CODES)[number];
};
